import { render, staticRenderFns } from "./addPackage.vue?vue&type=template&id=770255fa&scoped=true"
import script from "./addPackage.vue?vue&type=script&lang=js"
export * from "./addPackage.vue?vue&type=script&lang=js"
import style0 from "./addPackage.vue?vue&type=style&index=0&id=770255fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770255fa",
  null
  
)

export default component.exports